// import Wazaker from "../Wazaker/Wazaekr";
import React, { useEffect } from "react";
import GlobalStyle from "../../GlobalStyle";
import styled from "styled-components";
import { Switch, Route } from "react-router-dom";
import HomePage from "../../components/Pages/HomePage/HomePage";
import Masbaha from "../../components/Pages/Masbaha/Masbaha";
// import Navbar from "../../components/Navbar/Navbar";
import NavMenu from "../../components/NavMenu/NavMenu";
import FadleElzikr from "../../components/Pages/FadlElzikr/FadleElzikr";
import FavouriteAzkar from "../../components/Pages/FavouriteAzkar/FavouriteAzkar";
import AllAzkar from "../../components/Pages/AllAzkar/AllAzkar";
import Awrad from "../../components/Pages/Awrad/Awrad";
import AfterSalah from "../../components/Pages/AfterSalah/AfterSalah";
import AzkarSbah from "../../components/Pages/AzkarSbah/AzkarSbah";
import AzkarMsaa from "../../components/Pages/AzkarMsaa/AzkarMsaa";
import AzkarNoom from "../../components/Pages/AzkarNoom/AzkarNoom";
import AzkarTaam from "../../components/Pages/AzkarTaam/AzkarTaam";
import AzkarWdooa from "../../components/Pages/AzkarWdooa/AzkarWdooa";
import AzkarAzan from "../../components/Pages/AzkarAzan/AzkarAzan";
import AzkarMasjed from "../../components/Pages/AzkarMasjed/AzkarMasjed";
import AzkarManzel from "../../components/Pages/AzkarManzel/AzkarManzel";
import AzkarKhlaa from "../../components/Pages/AzkarKhlaa/AzkarKhlaa";
import AzkarHaj from "../../components/Pages/AzkarHaj/AzkarHaj";
import AzkarSafar from "../../components/Pages/AzkarSafar/AzkarSafar";
import AzkarMotafareqah from "../../components/Pages/AzkarMotafareqah/AzkarMotafareqah";
import AboutUs from "../../components/Pages/AboutUs/AboutUs";
import { AppProvider } from "../../components/AppProvider/AppProvider";

const MainApp = styled.div`
  position: relative;
  background: var(--min-color);
`;

const Wazaker = styled.div`
  width: 414px;
  height: 768px;
  background-color: var(--min-color);
  border: 2px solid rgba(var(--sec-color-rgba), 0.8);
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  box-shadow: 10px 10px 27px 9px rgba(0, 0, 0, 0.12);

  @media screen and (max-width: 1366px) {
    width: 320px;
    height: 568px;
  }

  @media screen and (orientation: landscape) and (max-device-width: 900px) {
    border-radius: 0;
    border: 0;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
  }
  @media screen and (max-width: 768px) {
    border-radius: 0;
    border: 0;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
  }
`;

function App() {
  useEffect(() => {
    document.title = "Wazaker";
  }, []);
  return (
    <AppProvider>
      <MainApp className="App">
        <GlobalStyle />
        <Wazaker>
          <NavMenu />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/masbaha" component={Masbaha} />
            <Route path="/fadle-elzikr" component={FadleElzikr} />
            <Route path="/favourite-azkar" component={FavouriteAzkar} />
            <Route path="/all-azkar" component={AllAzkar} />
            <Route path="/awrad" component={Awrad} />
            <Route path="/after-salah" component={AfterSalah} />
            <Route path="/azkar-alsbah" component={AzkarSbah} />
            <Route path="/azkar-almsaa" component={AzkarMsaa} />
            <Route path="/azkar-alnoom" component={AzkarNoom} />
            <Route path="/azkar-taam-shrab" component={AzkarTaam} />
            <Route path="/azkar-wdoua-salah" component={AzkarWdooa} />
            <Route path="/azkar-alazan" component={AzkarAzan} />
            <Route path="/azkar-almasjed" component={AzkarMasjed} />
            <Route path="/azkar-almanzel" component={AzkarManzel} />
            <Route path="/azkar-alkhlaa" component={AzkarKhlaa} />
            <Route path="/azkar-haj-omrah" component={AzkarHaj} />
            <Route path="/azkar-alsafar" component={AzkarSafar} />
            <Route path="/azkar-motafreqah" component={AzkarMotafareqah} />
            <Route path="/about-us" component={AboutUs} />
          </Switch>
        </Wazaker>
      </MainApp>
    </AppProvider>
  );
}

export default App;
